/*******************************************************
CLEAR SEARCH
Clears the search box and results.
********************************************************/

export default function clearSearch() {

    // Clear the input, clear the last search, and remove the clear button
    $("input[name='playersearch']")
        .val('')
        .data('lastsearch', '')
        .siblings('#player-search-clear').remove();  // eslint-disable-line newline-per-chained-call

    // Remove the search results
    $('#player-search-results').remove();
}
